module.exports = __webpack_public_path__ + "img/3.41bf3241.jpeg";